import { Routes, Route } from "react-router-dom";
import IntroductionScreen from "./IntroductionScreen";
import GlobalLeaderScreen from "./GlobalLeaderScreen";
import InnovationEvolutionScreen from "./InnovationEvolutionScreen";
import AddInnovationScreen from "./AddInnovationScreen";
import OnPremToCloudScreen from "./OnPremToCloudScreen";
import DeeperRelationshipsScreen from "./DeeperRelationshipsScreen";
import EliteCustomersScreen from "./EliteCustomersScreen";
import AllCloudScreen from "./AllCloudScreen";
import DedicatedCloudScreen from "./DedicatedCloudScreen";
import SupportServicesScreen from "./SupportServicesScreen";
import GlobalSupportServicesScreen from "./GlobalSupportServicesScreen";
import NoDevNeededScreen from "./NoDevNeededScreen";
import WhyAvayaScreen from "./WhyAvayaScreen";
import ReadyScreen from "./ReadyScreen";

function Navigation() {
  return (
    <Routes>
      <Route path="/" element={<IntroductionScreen />} />
      <Route path="/global-leader" element={<GlobalLeaderScreen />} />
      <Route
        path="/innovation-evolution"
        element={<InnovationEvolutionScreen />}
      />
      <Route path="/add-innovation" element={<AddInnovationScreen />} />
      <Route path="/on-prem-to-cloud" element={<OnPremToCloudScreen />} />
      <Route
        path="/deeper-relationships"
        element={<DeeperRelationshipsScreen />}
      />
      <Route path="/elite-customers" element={<EliteCustomersScreen />} />
      <Route path="/all-cloud" element={<AllCloudScreen />} />
      <Route path="/dedicated-cloud" element={<DedicatedCloudScreen />} />
      <Route path="/support-services" element={<SupportServicesScreen />} />
      <Route
        path="/global-support-services"
        element={<GlobalSupportServicesScreen />}
      />
      <Route path="/no-dev-needed" element={<NoDevNeededScreen />} />
      <Route path="/why-avaya" element={<WhyAvayaScreen />} />
      <Route path="/ready" element={<ReadyScreen />} />
    </Routes>
  );
}

export default Navigation;
